module.exports = __webpack_public_path__ + "img/SEJ_Eventos_carga de archivos.6f01b5d4.svg";